import type { FunctionComponent } from "react"

import { useParams } from "next/navigation"

import IconPen from "@jobteaser/ui-kit/assets/icons/jds_pen.svg"
import { Button, BUTTON_VARIANT } from "@jobteaser/ui-kit/components/Button"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { EVENT_EDITION_ROLES } from "@/modules/events/constants"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

import styles from "./Edition.module.css"

export const Edition: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const { dataCareerCenter } = useCareerCenterFetch()
  const locale = useLocale()
  const currentUser = useCurrentUserFetch()
  const currentUserRole = currentUser.dataCurrentUser?.attributes.roleTitle

  const hasEvents = !!dataCareerCenter?.careerCenterConf.modules.hasEvents

  const isRoleAuthorized = EVENT_EDITION_ROLES.includes(currentUserRole)

  if (!hasEvents || !isRoleAuthorized) {
    return null
  }

  return (
    <Button
      icon={IconPen}
      variant={BUTTON_VARIANT.GHOST}
      data-testid="event-details-edit-button"
      role="button"
      aria-label={t("event_details.button.edit")}
      className={styles.editButton}
      onClick={() => {
        window.open(`/${locale}/backend/events/${eventSlug}`, "_self")
      }}
    />
  )
}
